/**
 * App-wide settings. The one fixed value here is the demo sign-in code; everything else (accounts, users, projects, files) comes from the API.
 *
 * Browser storage is kept clean on purpose: only the signed-in user's id (`sessionKey`), the activity history (`historyKey`) and the
 * notifications (`notificationsKey`), both until the API has an endpoint for them, and the id of a design task still in progress (`generationTaskKeyPrefix`) are written. Nothing else is stored in the browser.
 */
export const appConfig = {
  /** Sign-in code for every account. For the demo only; must never be used for real authentication. */
  demoOtp: "123456",
  /** localStorage: the signed-in user's id. */
  sessionKey: 'supplylogic:user-id',
  /** localStorage: the activity history. */
  historyKey: 'supplylogic:history',
  /** localStorage: every notification (read ones too, as history), for every recipient that used this browser. */
  notificationsKey: 'supplylogic:notifications',
  /** localStorage: the background task still making a project's design, one entry per project (`<prefix><projectId>`), so a refresh can pick it back up. */
  generationTaskKeyPrefix: 'supplylogic:generation-task:',
  /** The most history entries kept in the browser. */
  historyLimit: 300,
  /** The most notifications kept in the browser, newest first; older ones drop off. */
  notificationsLimit: 500,
  notificationChannel: "supplylogic-prototype",
  defaultRoute: "/projects",
  /** A generation makes one design. More choices come as more versions, not as more designs at once. */
  designVariationsPerGeneration: 1,
  lookupDebounceMs: 400,
  lookupMinChars: 2,
  maxLogoPreviewBytes: 24576,
} as const
